import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { Campaign } from "../../models/campaign.model";
import { Integration } from "../../models/integration.model";
import { NationBuilderDataProvider } from "../../data-provider/nation-builder.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { IntegrationDataProvider } from "../../data-provider/integration.dp";
import { CanvassStatus } from "../../models/canvass-status.model";

let IntegrationStatusMappingComponent = {
    selector: "vcIntegrationStatusMapping",
    templateUrl:
        "/angular/components/integration/integration-status-mapping.component.html",
    bindings: {
        selectedIntegration: "=",
    },
    controller: class IntegrationStatusMapping {
        // * bindings for typescript compiler *
        public selectedIntegration: Integration;
        // ************************************

        public integration: Integration;
        public nationbuilder = false;
        public saving = false;
        public statusTypes: string[];
        public statuses: any[];
        public activeCampaign: Campaign;
        public canvassStatuses: any;

        private $scope: any;
        private $mdSelect: any;
        public __env: any;

        private dialog: DialogUtils;
        private dataProvider: IntegrationDataProvider;
        private nationBuilderDataProvider: NationBuilderDataProvider;

        constructor(
            $scope: any,
            $mdSelect: any,
            __env: any,
            DialogUtils: DialogUtils,
            IntegrationDataProvider: IntegrationDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            NationBuilderDataProvider: NationBuilderDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.$mdSelect = $mdSelect;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.dataProvider = IntegrationDataProvider;
            this.nationBuilderDataProvider = NationBuilderDataProvider;

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();

            CanvassStatusDataProvider.walkCanvassStatuses().then(
                (statuses: any) => (this.canvassStatuses = statuses)
            );
        }

        $onInit() {
            this.integration = _.cloneDeep(this.selectedIntegration);
            this.statusTypes =
                this.integration.key == "callhub"
                    ? ["disposition", "dispositions"]
                    : ["status", "statuses"];
            if (this.integration.key == "nationbuilder") {
                this.nationBuilderDataProvider
                    .getNationBuilderStatuses()
                    .then((statuses: any) => {
                        if (statuses) {
                            this.statuses = statuses;
                            this.nationbuilder = true;
                        }
                    });
            } else {
                if (
                    !this.integration.settings ||
                    this.integration.settings.length == 0
                ) {
                    this.integration.settings = {};
                }
                if (!this.integration.settings.statusMapping) {
                    this.integration.settings.statusMapping = _.cloneDeep(
                        this.dataProvider.defaultStatusMapping[
                            this.integration.key
                        ]
                    );
                }
                this.dataProvider
                    .getStatuses(this.integration.key)
                    .then((statuses: any) => {
                        this.statuses = statuses;
                    });
            }
        }

        statusMapped(id: string | number): boolean {
            if (!this.nationbuilder) {
                return false;
            }
            for (let key in this.integration.settings.statusMapping) {
                if (
                    this.integration.settings.statusMapping.hasOwnProperty(key)
                ) {
                    if (this.integration.settings.statusMapping[key] === id) {
                        return true;
                    }
                }
            }
            return false;
        }

        mappingSelected(): void {
            this.$mdSelect.hide();
        }

        openCanvassStatusDialog(ev: any): void {
            let canvassStatus = new CanvassStatus();
            this.dialog.show({
                component: "vc-canvass-status-form",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    selectedStatus: canvassStatus,
                },
                ariaLabel: "Create Interaction Status",
            });
        }

        confirm(integration: Integration): void {
            this.saving = true;
            if (this.nationbuilder) {
                this.dataProvider
                    .saveMapping(integration.key, this.canvassStatuses)
                    .then(() => this.dialog.hide(integration));
            } else {
                this.dataProvider
                    .updateSettings(integration.key, integration.settings)
                    .then(() => this.dialog.hide(integration));
            }
        }

        dismissDialog(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("integration")
    .component(
        IntegrationStatusMappingComponent.selector,
        IntegrationStatusMappingComponent
    );
